export const PAIR_LESSONS_PLUSES_LIST = [{
  headerKey: 'items.0.header',
  textKey: 'items.0.text'
}, {
  headerKey: 'items.1.header',
  textKey: 'items.1.text'
}, {
  headerKey: 'items.2.header',
  textKey: 'items.2.text'
}, {
  headerKey: 'items.3.header',
  textKey: 'items.3.text'
}];
export type PairLessonsPlusItem = (typeof PAIR_LESSONS_PLUSES_LIST)[number];